import { Box, Divider, List } from "@chakra-ui/react"
import React, { useEffect, useRef } from "react"
import { useInViewport } from "react-in-viewport"
import { PermissionsGroupFragment } from "../../graphql"
import { PermissionsGroupListItem } from "./PermissionsGroupListItem"

export type PermissionsGroupsListProps = {
	permissionsGroups: PermissionsGroupFragment[]
	loadMore: () => void
}

export const PermissionsGroupsList: React.FC<PermissionsGroupsListProps> = ({ permissionsGroups, loadMore }) => {
	const ref = useRef()

	const { inViewport } = useInViewport(ref as any, { threshold: 0.25 })

	useEffect(() => {
		if (inViewport) {
			loadMore()
		}
	}, [inViewport, loadMore])

	return (
		<List spacing={2}>
			{permissionsGroups.map((permissionsGroup) => (
				<>
					<PermissionsGroupListItem key={permissionsGroup._id} permissionsGroup={permissionsGroup} />
					<Divider />
				</>
			))}
			<Box w="full" h="2" ref={ref as any} />
		</List>
	)
}
